"use client"

import "./index.css"
import { Outlet, useLocation } from "react-router-dom"
import Header from "./components/Header"
import Footer from "./components/Footer"
import { useEffect, useState } from "react"
import summaryApi from "./common/index"
import Context from "./context/index"
import { useDispatch } from "react-redux"
import { setUserDetails } from "./store/userSlice"
import { Toaster } from "react-hot-toast"

function App() {
  const [cartProductCount, setCartProductCount] = useState(0)
  const [wishlistCount, setWishlistCount] = useState(0)
  const [isCartOpen, setIsCartOpen] = useState(false)

  const dispatch = useDispatch()
  const location = useLocation() // ✅ Get current route

  const fetchUserDetails = async () => {
    try {
      const dataResponse = await fetch(summaryApi.current_user.url, {
        method: summaryApi.current_user.method,
        credentials: "include",
      })
      const dataApi = await dataResponse.json()
      // Only set user if we get a successful response with actual user data
      if (dataApi.success && dataApi.data) {
        dispatch(setUserDetails(dataApi.data))
      } else {
        // Explicitly clear user if no valid session
        dispatch(setUserDetails(null))
      }
    } catch (error) {
      // On error, clear user state
      dispatch(setUserDetails(null))
    }
  }

  const fetchUserAddToCart = async () => {
    const dataResponse = await fetch(summaryApi.addToCartProductCount.url, {
      method: summaryApi.addToCartProductCount.method,
      credentials: "include",
    })
    const dataApi = await dataResponse.json()
    setCartProductCount(dataApi?.data?.count)
  }

  const fetchUserWishlistCount = async () => {
    const response = await fetch(summaryApi.countWishlistProducts.url, {
      method: summaryApi.countWishlistProducts.method,
      credentials: "include",
    })
    const dataApi = await response.json()
    setWishlistCount(dataApi?.data?.count)
  }

  const openCartSidebar = () => setIsCartOpen(true)
  const closeCartSidebar = () => setIsCartOpen(false)

  useEffect(() => {
    // Check if user just logged out
    const justLoggedOut = localStorage.getItem("justLoggedOut");
    
    if (justLoggedOut === "true") {
      // User just logged out - don't fetch user details
      dispatch(setUserDetails(null));
      // Clear the flag after a delay to prevent re-fetching
      setTimeout(() => {
        localStorage.removeItem("justLoggedOut");
      }, 1000);
    } else {
      // Normal flow - fetch user details
      fetchUserDetails()
      fetchUserWishlistCount()
      fetchUserAddToCart()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ✅ Hide navbar and sidebar on checkout page
  const hideHeaderAndSidebar = location.pathname === "/checkout"

  return (
    <>
      <Context.Provider
        value={{
          fetchUserDetails,
          cartProductCount,
          fetchUserAddToCart,
          wishlistCount,
          fetchUserWishlistCount,
          openCartSidebar,
          closeCartSidebar,
          isCartOpen,
        }}
      >
        {!hideHeaderAndSidebar && <Header />}
        <main className="min-h-[calc(100vh-110px)] bg-white">
          <Outlet />
        </main>
        {!hideHeaderAndSidebar && <Footer />}
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            duration: 3000,
            style: { background: "#363636", color: "#fff" },
            success: { duration: 3000, theme: { primary: "green", secondary: "black" } },
            error: { duration: 4000, theme: { primary: "red", secondary: "black" } },
          }}
        />
      </Context.Provider>
    </>
  )
}

export default App
